export const getMinAndMaxDates = (arr) => {
  const sortedDates = arr.sort((a, b) => a.getTime() - b.getTime());

  const startDate = new Date(Date.parse(sortedDates[0]));
  startDate.setDate(1);

  const endDate = new Date(Date.parse(sortedDates[sortedDates.length - 1]));
  endDate.setMonth(endDate.getMonth() + 1);
  endDate.setDate(0);

  return [startDate, endDate];
};

export function compareDatesForSorting(v1, v2) {
  const vp1 = Date.parse(v1);
  const vp2 = Date.parse(v2);
  if (vp1 > vp2) {
    return 1;
  } else if (vp1 < vp2) {
    return -1;
  }
  return 0;
}

export function parseDate(date, mode = "from") {
  if (typeof date !== "string") {
    return null;
  }

  const [day, month, year] = date.split(".");
  const hour = mode === "from" ? 0 : 23;
  const minutes = mode === "from" ? 0 : 59;
  const seconds = mode === "from" ? 0 : 59;
  const milliseconds = mode === "from" ? 0 : 999;
  return new Date(year, month - 1, day, hour, minutes, seconds, milliseconds);
}

/**
 * @var date = "2025-12-09T05:54:15.730Z"
 * @var locale = "ru-RU"
 * @return '09.12.2025'
 * */
export function getDateForView(date, locale) {
  return new Date(date).toLocaleDateString(locale, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
}

/**
 * @var date = new Date()
 * @return '09.12.2025'
 * */
export function getStringDateFromObject(date) {
  return date.toLocaleDateString("ru-RU");
}

/**
 * Format date as short string (dd.mm.yyyy)
 * @param {Date|string} date - Date object or ISO string
 * @return {string} - Formatted date string '09.12.2025'
 */
export function formatDateShort(date) {
  if (!date) return "";
  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

/**
 * Normalize date to UTC midnight (start of day)
 * This fixes timezone offset issues when sending dates to the backend
 * @param {Date} date - Date object in local time
 * @return {Date} - Date object at midnight UTC
 */
export function normalizeDateToUTC(date) {
  if (!date) return null;
  const d = new Date(date);
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0));
}
